<template>
<v-container>
    <v-layout>
      <v-flex xs12>
        <v-card class="elevation-11">
          <v-card-title primary-title>
            <h3>Lesson schedule</h3>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="lessons"
            hide-actions
            class="elevation-1"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.date | formatDateFull }}</td>
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-left">{{ props.item.lessonTime }}</td>
            </template>
            <template slot="no-data">
              <v-alert :value="true" color="error" icon="warning">
                Sorry, nothing to display here :(
              </v-alert>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { addDays, addMonths } from "date-fns"
import isWithinRange from "date-fns/is_within_range"
export default {
  data() {
    return {
      headers: [
        {
          text: "Date",
          align: "left",
          sortable: true,
          value: "date"
        },
        { text: "Student", value: "name", sortable: false },
        { text: "Time", value: "lessonTime", sortable: false }
      ]
    }
  },
  computed: {
    lessons() {
      let arrSorted = []
      let twoMonthsFromNow = addMonths(new Date(), 2)
      let oneWeekAgo = addDays(new Date(), -1)
      let arrLessons = this.$store.state.lessons.filter(el => {
        return isWithinRange(el.date, oneWeekAgo, twoMonthsFromNow)
      })
      return arrLessons.sort((a,b) => a.timestamp - b.timestamp)
    }
  }
}
</script>

<style scoped>
.container {
  padding: 0px;
}

h3 {
  font-size: 1.25rem;
  font-weight: bold;
}
</style>